module.exports = __webpack_public_path__ + "img/android.36c3b60a.png";